import React from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';

import OPComponent from '../op_component';
import CachedImage from './cached_image';
import Navigation from '../../../navigation';

import { __WEB__ } from '../../../constants/styles';

import { getFullscreenImageUrl } from './web_fullscreen';

const IMAGE_WIDTH = 90;
const IMAGE_HEIGHT = 60;

export default class AttachmentsList extends OPComponent {
  constructor(props) {
    super(props);
  }

  showFullScreen = attachment => {
    this.showFullScreenImage(attachment);
  };

  showFullScreenImage = async attachment => {
    if (__WEB__) {
      const url = await getFullscreenImageUrl(attachment);
      if (url) window.open(url, '_blank');
      return;
    }
    Navigation.showModal({
      screen: 'FullscreenImageModal',
      title: '',
      passProps: {
        attachments: this.props.attachments,
        attachment,
      },
    });
  };

  renderCachedImage = (attachment, i) => {
    return (
      <View key={i} style={styles.imageContainer}>
        <CachedImage
          width={IMAGE_WIDTH}
          height={IMAGE_HEIGHT}
          attachment={attachment}
          isThumb={true}
          onPress={this.showFullScreen}
        />
      </View>
    );
  };

  render() {
    const { attachments, constainerStyle } = this.props;

    if (!attachments || !attachments.length) return null;

    return (
      <View style={[styles.images, constainerStyle]}>
        <ScrollView horizontal={true}>{attachments.map(this.renderCachedImage)}</ScrollView>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  images: {
    height: 90,
    // backgroundColor: 'pink'
  },
  imageContainer: {
    marginRight: 10,
    borderRadius: 8,
    overflow: 'hidden',
    width: IMAGE_WIDTH,
    height: IMAGE_HEIGHT,
  },
});
